import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { LogoMark } from "@/components/LogoMark";
import { Loader2 } from "lucide-react";

function formatError(detail) {
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-[100svh] place-items-center bg-[#F1F5F9] px-5">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <LogoMark className="mx-auto h-10" />
          <p className="mt-3 text-sm text-[#64748B]">Staff Administration</p>
        </div>
        <form onSubmit={submit} className="maqam-card space-y-4 rounded-3xl p-7" data-testid="admin-login-form">
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" required />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" required />
          </div>
          {error && <p className="text-sm text-[#C62828]" data-testid="admin-login-error">{error}</p>}
          <Button type="submit" disabled={busy} data-testid="admin-login-submit" className="w-full gap-2 bg-[#0A192F] hover:bg-[#112240]">
            {busy && <Loader2 size={16} className="animate-spin" />} Sign in
          </Button>
        </form>
      </div>
    </div>
  );
}
